import { defineAsyncComponent, markRaw } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";

export const tileConfigs: TileConfigType = {
  IHWeakPointParetoTile: {
    active: true,
    settingsModule: markRaw(
      defineAsyncComponent(
        () =>
          import("@/modules/tiles/components/ihWeakPointParetoTile/IHWeakPointParetoTileSettings.vue"),
      ),
    ),
    component: markRaw(
      defineAsyncComponent(
        () => import("@/modules/tiles/components/ihWeakPointParetoTile/IHWeakPointParetoTile.vue"),
      ),
    ),
    icon: "fas fa-tools",
  },
};
